
































































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { bookingModule } from '@/store';

@Component({
  components: {},
})
export default class extends Vue {
  valid: boolean = false;

  startDateMenu: boolean = false;
  endDateMenu: boolean = false;

  startDate: string = moment().format('YYYY-MM-DD');
  endDate: string = moment().format('YYYY-MM-DD');

  futureDate = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .futureDate()
        .test(v) || 'Date must be in the future.',
  ];

  returnDate = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .endDate()
        .test(v) || 'Date must be after the departure date.',
  ];

  get formattedStartDate() {
    if (!this.startDate) {
      return '';
    }
    return moment(this.startDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }

  get formattedEndDate() {
    if (!this.endDate) {
      return '';
    }
    return moment(this.endDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }

  updateEndDate() {
    if (moment(this.startDate).diff(moment(this.endDate), 'days') > 0) {
      this.endDate = this.startDate;
    }
  }

  getQuote() {
    bookingModule.setStartDate(this.startDate);
    bookingModule.setEndDate(this.endDate);

    this.$router.push({
      name: 'booking-step-1',
    });
  }

  beforeMount() {
    const futureDate = () => {
      return (value: string) =>
        moment(value, 'D/M/YYYY').diff(moment(), 'days') >= 0;
    };
    const endDate = () => {
      return (value: string) =>
        moment(value, 'D/M/YYYY').diff(moment(this.startDate), 'days') >= 0;
    };
    v8n.extend({ futureDate, endDate });
  }
}
